import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { IconComponent, IconName } from '@recruitee/user-interface';

import { EmojiComponent } from '../emoji/emoji.component';
import { IconFontComponent } from '../icon-font/icon-font.component';
import { AnySymbol } from '../symbol.types';

@Component({
  selector: 'rt-symbol',
  standalone: true,
  imports: [EmojiComponent, IconComponent, IconFontComponent],
  templateUrl: './symbol.component.html',
  styleUrls: ['./symbol.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SymbolComponent {
  public symbol = input.required<AnySymbol | null>();
  public fallbackSymbol = input<AnySymbol>();
  public fallbackIcon = input<IconName>();
  public forceFallback = input<boolean>(false);

  public displaySymbol = computed(
    (): AnySymbol | null => this.symbol() ?? this.fallbackSymbol() ?? null,
  );
}
